var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"fail"},[_vm._m(0),_c('p',{staticClass:"waiting"},[_vm._v("该分享码已失效...")]),_c('div',{staticClass:"btns",on:{"click":_vm.onPage}},[_c('button',{staticClass:"shopping"},[_vm._v("去首页")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image"},[_c('img',{attrs:{"src":require("../../../assets/images/shareCodeFail.png"),"alt":""}})])
}]

export { render, staticRenderFns }